// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import moment from 'moment'

window.moment = moment;
import 'moment/locale/cs';
window.moment.locale("cs");

var MobileDetect = require('mobile-detect');
window.MobileDetect = new MobileDetect(window.navigator.userAgent);

import Meny from '@/components/Meny'
Vue.component("meny", Meny);

import Dostupnost from '@/components/Dostupnost'
Vue.component("dostupnost", Dostupnost);

import Kategorie from '@/components/Kategorie'
Vue.component("kategorie", Kategorie);

import Kraje from '@/components/Kraje'
Vue.component("kraje", Kraje);

import Vyrobci from '@/components/Vyrobci'
Vue.component("vyrobci", Vyrobci);

import Material from '@/components/Material'
Vue.component("material", Material);

import Zeme from '@/components/Zeme'
Vue.component("zeme", Zeme);

import ZpusobyDoruceni from '@/components/ZpusobyDoruceni'
Vue.component("zpusoby-doruceni", ZpusobyDoruceni);
Vue.component("zpusobydoruceni", ZpusobyDoruceni);


import Domena from '@/components/Domena'
Vue.component("domena", Domena);

import ProductSearch from '@/components/ProductSearch'
Vue.component("productsearch", ProductSearch);

import SporiciProduktSearch from '@/components/SporiciProduktSearch'
Vue.component("sporiciproduktsearch", SporiciProduktSearch);
Vue.component("sporici-produkt-search", SporiciProduktSearch);

import SporiciCilovyProduktSearch from '@/components/SporiciCilovyProduktSearch'
Vue.component("sporicicilovyproduktsearch", SporiciCilovyProduktSearch);
Vue.component("sporici-cilovy-produkt-search", SporiciCilovyProduktSearch);

import TypOsoby from '@/components/TypOsoby'
Vue.component("typosoby", TypOsoby);

import ClientSearch from '@/components/ClientSearch'
Vue.component("clientsearch", ClientSearch);

import OsobaSearch from '@/components/OsobaSearch'
Vue.component("osobasearch", OsobaSearch);

import Ucty from '@/components/Ucty'
Vue.component("ucty", Ucty);

import DateTimePicker from '@/components/DateTimePicker'
Vue.component("datetimepicker", DateTimePicker);

import DatePicker from '@/components/DatePicker'
Vue.component("datepicker", DatePicker);

import Sklady from '@/components/Sklady'
Vue.component("sklady", Sklady);

import KarieraSelect from '@/components/KarieraSelect'
Vue.component("kariera-select", KarieraSelect);

import SerioveCisloSearch from '@/components/SerioveCisloSearch'
Vue.component("seriove-cislo-search", SerioveCisloSearch);
Vue.component("seriovecislosearch", SerioveCisloSearch);

import Dodavatele from '@/components/Dodavatele'
Vue.component("dodavatele", Dodavatele);

import DodavateleSelect from '@/components/DodavateleSelect'
Vue.component("dodavateleselect", DodavateleSelect);

import DodavateleProduktuSelect from '@/components/DodavateleProduktuSelect'
Vue.component("dodavateleproduktuselect", DodavateleProduktuSelect);

import NahradniProduktySelect from '@/components/NahradniProduktySelect'
Vue.component("nahradniproduktyuselect", NahradniProduktySelect);

import Obdobi from '@/components/Obdobi'
Vue.component("obdobi", Obdobi);

import Adresa from '@/components/Adresa'
Vue.component("adresa", Adresa);

import AdresaView from '@/components/AdresaView'
Vue.component("adresa-view", AdresaView);
Vue.component("adresaview", AdresaView);

import VyberAdresy from '@/components/VyberAdresy'
Vue.component("vyber-adresy", VyberAdresy);

import SazbaDPH from '@/components/SazbaDPH'
Vue.component("sazbadph", SazbaDPH);
Vue.component("sazba-dph", SazbaDPH);

import StavObjednavky from '@/components/StavObjednavky'
Vue.component("stavobjednavky", StavObjednavky);
Vue.component("stav-objednavky", StavObjednavky);

import TypDokumentu from '@/components/TypDokumentu'
Vue.component("typdokumentu", TypDokumentu);
Vue.component("typ-dokumentu", TypDokumentu);

import StavObjednavkySelect from '@/components/StavObjednavkySelect'
Vue.component("stavobjednavkyselect", StavObjednavkySelect);
Vue.component("stav-objednavky-select", StavObjednavky);

import SpolupracovniciPodrizeni from '@/components/SpolupracovniciPodrizeni'
Vue.component("spolupracovnici-podrizeni", SpolupracovniciPodrizeni);

import ZaplacenoProcent from '@/components/ZaplacenoProcent'
Vue.component("zaplaceno-procent", ZaplacenoProcent);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

import ButtonToggle from '@/components/ButtonToggle'
Vue.component("buttonToggle", ButtonToggle);
Vue.component("button-toggle", ButtonToggle);

Vue.component('apexchart', VueApexCharts)

window.moment = moment;
Vue.use(moment);

import 'vuetify/dist/vuetify.min.css'
import 'fullcalendar/dist/fullcalendar.css'
import './assets/css/style.css';

import czLocale from './locales/cz'

Vue.use(Vuetify, {
  lang: {
    locales: { 'cz': czLocale },
    current: 'cz'
  }
})

import TmplHelper from './assets/th.js';
window.TH = TmplHelper;
window.th = TmplHelper;

import API from './assets/api.js'
window.API = API;
window.api = API;

Vue.config.productionTip = false

// Contabo/AWS S3 migrace - process.env.* nejde použít přímo v <template> (šablonový
// kompilátor ho prefixuje _vm., DefinePlugin to nenahradí), proto se vystavuje jako
// property instance. Viz classes/S3.php v commodity_api_original pro odpovídající
// backendovou stranu (AWS_S3_ENDPOINT / AWS_S3_USE_PATH_STYLE).
Vue.prototype.$imagesBaseUrl = process.env.VUE_APP_PUBLIC_IMAGES_BASE_URL;
Vue.prototype.$salesmanInvoicesBaseUrl = process.env.VUE_APP_PUBLIC_SALESMAN_INVOICES_BASE_URL;

import FullCalendar from 'vue-full-calendar'
Vue.use(FullCalendar)
import './assets/calendar.css'

import MenuListener from './assets/menu-listener.js'
window.MenuListener = MenuListener;

import UploadListener from './assets/upload-listener.js'
window.UploadListener = UploadListener;

if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('DD.MM.YYYY HH:mm')
  }
});

Vue.filter('formatDateFull', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('DD.MM.YYYY HH:mm:ss')
  }
});

Vue.filter('formatSimpleDate', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('DD.MM.YYYY')
  }
});

Vue.filter('formatDateMonth', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('MMMM YYYY').substr(0, 1).toUpperCase() + moment(new Date(value*1000)).format('MMMM YYYY').substr(1)
  }
});

Vue.filter('formatInt', function(value) {
  if (value) {
    return window.th.formatPrice(value, 0, ",", " ")
  }
  return "0";
});

Vue.filter('formatMoney', function(value) {
  if (value) {
    return window.th.formatPrice(value, 2, ",", " ")
  }
  return "0,00";
});

Vue.filter('formatMoneyInt', function(value) {
  if (value) {
    return window.th.formatPrice(value, 0, ",", " ")
  }
  return "0,00";
});

Vue.filter('formatDouble', function(value) {
  if (value) {
    return window.th.formatDouble(value)
  }
  return "0,00";
});

Vue.filter('formatPrice', function(value) {
  if (value) {
    return window.th.formatPrice(value, 2, ",", " ")
  }
  return "0,00";
});

Vue.filter('formatFileSize', function(value) {
  if (value) {
    return window.th.humanFileSize(value, true)
  }
  return "";
});

Vue.filter('lowerCase', function(value) {
  if (value) {
    return value.toString().toLowerCase()
  }
  return "";
});

Vue.filter('upperCase', function(value) {
  if (value) {
    console.log(value.toString().toUpperCase())
    return value.toString().toUpperCase()
  }
  return "";
});

import Loader from './components/Loader'
Vue.component('Loader', Loader);

import Base from './pages/Base.vue'
Vue.use(Base)

Array.prototype.clear = function() {
  while (this.length) {
    this.pop();
  }
};

Array.prototype.merge = function(arr) {
  if (arr != null)
    for (var $i = 0; $i < arr.length; $i++)
      this.push(arr[$i]);
};

Array.prototype.replace = function(arr) {
  this.clear();
  this.merge(arr);
};

if (!Array.prototype.filterOne)
  Array.prototype.filterOne = function(e) {
    var f = this.filter(e);
    return f.length > 0 ? f[0] : null;
  }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js